export const getEsignFlowId = state => state.esignFlows.esignFlow.id;
export const getEsignFlowData = state => state.esignFlows.esignFlow;
export const esignFlowIsFetching = state => state.esignFlows.loading;